import { SupabaseClient } from "@supabase/supabase-js";
import { cloneDeep } from "es-toolkit/object";
import { buildSupabasePublicUrl } from "components/Image/utils";
import { BeforeAfterCategoryData } from "./types";

export const getCategoriesDynamicTabs = async (
  supabaseClient: SupabaseClient,
  categories: BeforeAfterCategoryData[]
) => {
  if (!categories.length) {
    return { categories: [] };
  }

  const beforeAfterResponses = await Promise.all(
    categories.map((category) => {
      let supabaseRef = supabaseClient
        .from("before_after")
        .select("*, before_file_id(id, path), after_file_id(id, path)");
      if (category.dynamicTabsProjectId) {
        supabaseRef = supabaseRef.eq("project_id", category.dynamicTabsProjectId);
      }
      if (category.dynamicTabsSpaceId) {
        supabaseRef = supabaseRef.eq("space_id", category.dynamicTabsSpaceId);
      }
      return supabaseRef.eq("website_display", true).eq("is_deleted", false).eq("workspace_id", 1);
    })
  );

  const finalData = cloneDeep(categories);

  beforeAfterResponses.forEach((response, index) => {
    const { data } = response;
    if (data?.length) {
      finalData[index].tabs = data
        .filter((item) => !!item.name)
        .map((item) => {
          return {
            title: item.name,
            beforeImageUrl: item.before_file_id?.path
              ? buildSupabasePublicUrl(item.before_file_id?.path)
              : item.before_file_id?.path,
            afterImageUrl: item.after_file_id?.path
              ? buildSupabasePublicUrl(item.after_file_id?.path)
              : item.after_file_id?.path
          };
        });
    }
  });

  return {
    categories: finalData
  };
};
